const VISIBILITY_HIDE_EVENTS = ['visibilitychange', 'pagehide', 'beforeunload'];
const VISIBILITY_SHOW_EVENTS = ['visibilitychange', 'pageshow'];

/**
 * Функция подписки на скрытие/закрытие страницы
 *
 * @param cb коллбэк, который будет вызван на скрытие страницы
 * @returns функцию отписки
 */
export function subscribeToPageHide(cb: () => void) {
    // Если со страницы ушли еще до регистрации слушателей,
    // например, при открытии страницы в новой вклдке без перехода на нее.
    if (document.visibilityState === 'hidden') {
        cb();
    }
    function pageHideListener(event: Event) {
        if (event.type === 'pagehide' || event.type === 'beforeunload' || document.visibilityState === 'hidden') {
            cb();
        }
    }

    VISIBILITY_HIDE_EVENTS.forEach(eventType => addEventListener(eventType, pageHideListener, true));

    return () => VISIBILITY_HIDE_EVENTS.forEach(eventType => removeEventListener(eventType, pageHideListener, true));
}

export function subscribeToPageShow(cb: (event: Event) => void) {
    function pageShowListener(event: Event) {
        if (event.type === 'pageshow' || document.visibilityState === 'visible') {
            cb(event);
        }
    }
    VISIBILITY_SHOW_EVENTS.forEach(eventType => addEventListener(eventType, pageShowListener, true));

    return () => VISIBILITY_SHOW_EVENTS.forEach(eventType => removeEventListener(eventType, pageShowListener, true));
}
